import React, { useState } from "react";
import "./FiveStarRatingModal.css";
import expertDefaultImg from "../images/expert-default.png";

const FiveStarRatingModal = ({
  experts = [],
  onSubmit,
  onSkip,
  initialRatings = {},
  initialComments = {},
  loading = false,
}) => {
  const [ratings, setRatings] = useState(initialRatings);
  const [comments, setComments] = useState(initialComments);
  const [submitting, setSubmitting] = useState(false);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";

  const handleStarClick = (expertId, rating) => {
    setRatings((prev) => ({ ...prev, [expertId]: rating }));
  };

  const handleCommentChange = (expertId, comment) => {
    setComments((prev) => ({ ...prev, [expertId]: comment }));
  };

  const renderStars = (expertId, currentRating = 0) => {
    return Array.from({ length: 5 }, (_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={index}
          className={`rating-star ${
            starValue <= currentRating ? "filled" : ""
          }`}
          onClick={() => handleStarClick(expertId, starValue)}
          style={{
            fontSize: "24px",
            color: starValue <= currentRating ? "#ffd700" : "#ddd",
            cursor: "pointer",
            marginRight: "5px",
            transition: "color 0.2s",
          }}
        >
          ★
        </span>
      );
    });
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    await onSubmit(ratings, comments);
    setSubmitting(false);
  };

  return (
    <div className="rating-modal-overlay">
      <div className="rating-modal-card">
        <button
          className="rating-modal-close"
          onClick={onSkip}
          title="Close"
          disabled={submitting || loading}
        >
          &times;
        </button>
        <div className="rating-modal-header">
          <span className="rating-modal-icon">⭐</span>
          <h2>Rate Your Experience</h2>
          <p>Please rate the consultants who worked on this project</p>
        </div>
        <div className="rating-modal-content">
          {experts.map((expert, index) => (
            <div key={expert.id} className="rating-expert-card">
              <div className="rating-expert-header">
                <div className="rating-expert-avatar">
                  {expert.expertPicture ? (
                    <img
                      src={
                        expert?.expertPicture?.includes(mediaLink)
                          ? expert?.expertPicture
                          : `${databaseLink}${expert?.expertPicture}`
                      }
                      alt={expert.expertName}
                      onError={(e) => (e.target.src = expertDefaultImg)}
                    />
                  ) : (
                    <span>
                      {expert.expertName
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()
                        .slice(0, 2)}
                    </span>
                  )}
                </div>
                <div>
                  <h4>{expert.expertName}</h4>
                  {experts.length > 1 && (
                    <span className="rating-expert-progress">
                      {index + 1} of {experts.length}
                    </span>
                  )}
                </div>
              </div>
              <div className="rating-expert-stars">
                {renderStars(expert.ID, ratings[expert.ID] || 0)}
                <span className="rating-expert-label">
                  {ratings[expert.ID] === 1 && "Poor"}
                  {ratings[expert.ID] === 2 && "Fair"}
                  {ratings[expert.ID] === 3 && "Good"}
                  {ratings[expert.ID] === 4 && "Very Good"}
                  {ratings[expert.ID] === 5 && "Excellent"}
                  {!ratings[expert.ID] && "Click stars to rate"}
                </span>
              </div>
              <textarea
                className="rating-textarea"
                value={comments[expert.ID] || ""}
                onChange={(e) => handleCommentChange(expert.ID, e.target.value)}
                placeholder="Share your feedback about this consultant..."
                disabled={submitting || loading}
              />
            </div>
          ))}
        </div>
        <div className="rating-modal-actions">
          <button
            type="button"
            className="btn btn-light"
            onClick={onSkip}
            disabled={submitting || loading}
          >
            Skip Rating
          </button>
          <button
            type="button"
            className="btn base-btn"
            onClick={handleSubmit}
            disabled={submitting || loading}
          >
            {submitting || loading ? "Submitting..." : "Submit Ratings"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiveStarRatingModal;
